import { combineReducers } from 'redux'
import shipback from './shipback'
import company from './company'
import breadcrumb from './breadcrumb'
import customer from './customer'
import items from './items'
import quotes from './quotes'
import user from './user'
import sizes from './sizes'

const reduxApp = combineReducers({
  company,
  shipback,
  breadcrumb,
  customer,
  items,
  quotes,
  user,
  sizes,
})

export default reduxApp


// WEBPACK FOOTER //
// ./app/javascript/components/reducers/index.js